import {
  ClockClockwise,
  Cookie,
  CurrencyCircleDollar,
  FileText,
  House,
  GlobeHemisphereWest,
  Receipt,
  SignOut,
  Swap,
  Wallet,
} from '@phosphor-icons/react';
import { APP_VERSION } from './app'
import React from 'react';
import { FEATURE_FLAGS } from './feature-flags';
export interface IMenuLink {
  icon?: React.ReactNode
  name: string
  link: string
  class?: string
}

export interface IMenuItem {
  label: string | React.ReactNode
  links?: IMenuLink[]
  class?: string
}

export const menu_define = (t: (key: string) => string): IMenuItem[] => [
  {
    label: null,
    links: [
      {
        icon: <House size={24} color="#000" weight="fill" />,
        name: `${t('sidebar.my_portfolio')}`,
        link: '/',
      },
    ],
    class: 'sidebar-section-no-padding',
  },
  {
    label: `${t('sidebar.wealth_products')}`,
    links: [
      {
        icon: (
          <CurrencyCircleDollar size={24} weight={'thin'} />
        ),
        name:`${t('sidebar.main_account')}`,
        link: '/main-account/',
      },
      ...(FEATURE_FLAGS.EXCHANGE_ENABLED ? [{
        icon: (
          <Swap size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />
        ),
        name: `${t('sidebar.exchange')}`,
        link: '/exchange/',
      }] : []),
      {
        icon: (
          <ClockClockwise
            size={24}
            weight={'thin'}
            color={'rgb(116, 116, 127)'}
          />
        ),
        name: `${t('sidebar.dca_strategy')}`,
        link: '/dca-strategy/',
      },
      {
        icon: (
          <Wallet
            size={24}
            weight={'thin'}
            color={'rgb(116, 116, 127)'}
          />
        ),
        name: `${t('sidebar.management_mandate')}`,
        link: '/management-mandate/',
      },
      // {
      //   icon: (
      //     <GlobeHemisphereWest
      //       size={24}
      //       weight={'thin'}
      //       color={'rgb(116, 116, 127)'}
      //     />
      //   ),
      //   name: `${t('sidebar.rwa_market')}`,
      //   link: 'https://rwa.davensi.com/portfolio',
      // },
      // {
      //   icon: (
      //     <GlobeHemisphereWest
      //       size={24}
      //       weight={'thin'}
      //       color={'rgb(116, 116, 127)'}
      //     />
      //   ),
      //   name: `${t('sidebar.rwa')}`,
      //   link: '/rwa/',
      // },
    ],
  },
  // TODO: DAV-61
  // {
  //   label: `${t('sidebar.about_us')}`,
  //   links: [
  //     {
  //       icon: <Receipt size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
  //       name: `${t('sidebar.pricing')}`,
  //       link: '/about-us/pricing/',
  //     },
  //     {
  //       icon: <BookOpen size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
  //       name: `${t('sidebar.our_story')}`,
  //       link: '/about-us/our-story/',
  //     },
  //     {
  //       icon: <Files size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
  //       name: `${t('sidebar.documentation')}`,
  //       link: '/about-us/documentation/',
  //     }
  //   ]
  // },
  {
    label: `${t('sidebar.legal')}`,
    links: [
      {
        icon: <FileText size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.terms_of_use')}`,
        link: '/legal/terms-of-use/',
      },
      {
        icon: <FileText size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.legal_notices')}`,
        link: '/legal/legal-notices/',
      },
      {
        icon: <Cookie size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.cookie_management_policy')}`,
        link: '/legal/cookie-management-policy/',
      },
      {
        icon: <Receipt size={24} weight={'thin'} color={'rgb(116, 116, 127)'} />,
        name: `${t('sidebar.fees')}`,
        link: '/legal/fees/',
      },
    ],
  },
  {
    label: null,
    class: 'sidebar-section-no-padding',
    links: [
      {
        icon: <SignOut size={24} weight="thin" color="#FF0000" />,
        name: `${t('sidebar.logout')}`,
        link: '/auth/login',
        class: 'logout',
      },
    ],
  },
  {
    label: <span style={{ textAlign: 'center', width: "100%", display: 'inline-block', marginLeft: -12 }}>{APP_VERSION}</span>,
    class: 'sidebar-section-no-padding'
  },
]
